"use strict";
/** family: SingleSelect **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var constants_1 = require("../constants");
var DropdownButton_1 = require("../DropdownButton");
var SearchInput_1 = require("../SearchInput");
var CLASS_NAME = 'i-single-select-search';
var SingleSelectSearch = /** @class */ (function (_super) {
    __extends(SingleSelectSearch, _super);
    function SingleSelectSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.getButtonLabel = function (label, selectedItem) {
            return "" + label + (selectedItem ? ": " + selectedItem.label : '');
        };
        _this.handleChange = function (e) {
            var value = e.target.value;
            _this.setState({ searchText: value, isLoading: true }, function () {
                _this.changeSubject.next(value);
            });
        };
        _this.handleClear = function () {
            _this.setState({ searchText: '', searchResults: [] }, function () {
                _this.changeSubject.next('');
            });
        };
        _this.handleSelect = function (e, item) {
            e.stopPropagation();
            _this.props.onSelect(e, item);
        };
        _this.handleToggle = function (isVisible) {
            // If visibility is changed and is `true`:
            if (isVisible) {
                // Clear the search input box and search results.
                _this.setState({
                    searchResults: [],
                    searchText: '',
                });
            }
        };
        _this.renderDivider = function (key) { return (React.createElement(DropdownButton_1.DropdownButton.Item, { divider: true, key: key })); };
        _this.renderItems = function (items) {
            return items.map(function (item, index) { return (React.createElement(DropdownButton_1.DropdownButton.Item, { key: index, onClick: function (event) { return _this.handleSelect(event, item); } },
                React.createElement("span", { className: CLASS_NAME + "__label" }, item.label))); });
        };
        _this.renderNoResultsMessage = function () { return (React.createElement(DropdownButton_1.DropdownButton.Item, { key: "no-results", readOnly: true, className: CLASS_NAME + "__item--no-results" }, _this.props.noResultsText)); };
        _this.renderSearchResults = function () {
            var items = !!_this.state.searchText
                ? _this.state.searchResults
                : _this.props.defaultItems;
            var searchResults = []
                .concat(_this.renderItems(items.slice(0, _this.props.maxItems)), _this.shouldRenderNoResultsMessage(items) &&
                _this.renderNoResultsMessage())
                .filter(function (item) { return !!item; });
            return searchResults.length > 0 && searchResults;
        };
        _this.subscribeToChange = function () {
            _this.changeSubject = new rxjs_1.Subject();
            _this.changeSubscription = _this.changeSubject
                .pipe(operators_1.debounceTime(_this.props.debounceTime), operators_1.distinctUntilChanged(), operators_1.switchMap(function (value) { return rxjs_1.from(_this.props.onSearch(value)); }))
                .subscribe(function (searchResults) {
                _this.setState({ searchResults: searchResults, isLoading: false });
            });
        };
        _this.unsubscribeFromChange = function () {
            _this.changeSubscription.unsubscribe();
        };
        _this.state = {
            isLoading: false,
            searchResults: [],
            searchText: '',
        };
        return _this;
    }
    SingleSelectSearch.prototype.componentDidMount = function () {
        this.subscribeToChange();
    };
    SingleSelectSearch.prototype.componentWillUnmount = function () {
        this.unsubscribeFromChange();
    };
    SingleSelectSearch.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, label = _a.label, searchInputPlaceholderText = _a.searchInputPlaceholderText, selectedItem = _a.selectedItem, restProps = __rest(_a, ["children", "className", "label", "searchInputPlaceholderText", "selectedItem"]);
        return (React.createElement(DropdownButton_1.DropdownButton, __assign({ className: classNames(CLASS_NAME, className), label: this.getButtonLabel(label, selectedItem), role: DropdownButton_1.DropdownButton.Role.Menu, onToggle: this.handleToggle }, restProps),
            React.createElement(DropdownButton_1.DropdownButton.Item, { key: "search", readOnly: true },
                React.createElement(SearchInput_1.SearchInput, { className: CLASS_NAME + "__search-input", onChange: this.handleChange, onClear: this.handleClear, placeholder: searchInputPlaceholderText, showLoader: this.state.isLoading, value: this.state.searchText })),
            this.renderDivider('divider'),
            this.renderSearchResults()));
    };
    SingleSelectSearch.prototype.shouldRenderNoResultsMessage = function (items) {
        return !this.state.isLoading && items.length === 0;
    };
    SingleSelectSearch.defaultProps = {
        debounceTime: constants_1.DEFAULT_DEBOUNCE_TIME,
        defaultItems: Array(),
    };
    return SingleSelectSearch;
}(React.Component));
exports.SingleSelectSearch = SingleSelectSearch;
//# sourceMappingURL=SingleSelectSearch.js.map